import CallHistoryService from '../js/callHistoryService';
import objectMerge from 'object-merge';
import LoggingService from 's2s-logging-service';

const callInfo = (state, action)=>{
  if (typeof state === 'undefined') {
    const h = CallHistoryService.getInstance().getHistory();
    let lastNumber;
    if (h && h.length > 0){
      lastNumber = h[0].callerId;
    }

    return  {
              lastNumber: lastNumber,
              activeCallId: undefined,
              incomingCalls: {},
              inprogressCalls: {},
              voicemailCount: 0,
              dialPlanOptions: {}
            };
  }

  const oStateReturn = objectMerge({}, state);// { ...state };


  switch (action.type) {

    case 'CALL_MUTED':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- CALL_MUTED', action.payload)

      //oStateReturn['inprogressCalls'][action.payload.callId]['dialog'] = action.payload.dialog;
      oStateReturn['inprogressCalls'][action.payload.callId]['muted'] = action.payload.dialog.params.isMuted ? true : false;
      LoggingService.getInstance().debug('*****', oStateReturn['inprogressCalls'][action.payload.callId])
      return oStateReturn;

    case 'CALL_HELD':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- CALL_HELD', action.payload)
      LoggingService.getInstance().debug('------', oStateReturn);
      oStateReturn['inprogressCalls'][action.payload.callId]['held'] = action.payload.dialog.params.isHeld ? true : false;
      return oStateReturn;

    case 'DIAL_PLAN_OPTIONS':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- DIAL_PLAN_OPTIONS', action.payload)
      oStateReturn['dialPlanOptions'] = action.payload;
      return oStateReturn;

    case 'INITIAL_VOICEMAIL':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- INITIAL_VOICEMAIL', action.payload)

      oStateReturn['voicemailCount'] = action.payload.unreadcount;
      return oStateReturn;

    case 'VOICEMAIL_COUNT':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- VOICEMAIL_COUNT', action.payload)

      oStateReturn.voicemailCount = action.payload;
      return oStateReturn;

    case 'CALLING':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- CALLING', action.payload)

      // // if action.payload.callerName is undefined, then set it to 'Outbound Call'
      // if (!action.payload.callerName && action.payload.direction === 'outbound') {
      //   action.payload.callerName = 'Outbound Call';
      // }

      // Add timestamp if not there (VertoService will populate when active call)
      if (!action.payload.timestamp) {
        action.payload.timestamp = Date.now();
      }

      oStateReturn.lastNumber = action.payload.destination;
      oStateReturn.activeCallId = action.payload.callId;

      if (action.payload.dialog){
        delete action.payload.dialog;
      }
      if (!action.payload.hasOwnProperty('muted')){
        action.payload.muted = false;
      }
      if (!action.payload.hasOwnProperty('held')){
        action.payload.held = false;
      }
      oStateReturn.inprogressCalls[action.payload.callId] = action.payload;
      // remove it from incoming if you answered it
      if (oStateReturn.incomingCalls && oStateReturn.incomingCalls[action.payload.callId] ){
        // delete
        delete oStateReturn.incomingCalls[action.payload.callId];
      }
      return oStateReturn;

    case "INCOMING_CALL":
      LoggingService.getInstance().debug('CALLINFO REDUCER --- INCOMING_CALL', action.payload);
      oStateReturn.incomingCalls[action.payload.callid] = {"muted": false, "held": false, "id": action.payload.callid, "params": action.payload.params, "state": action.payload.state, "direction": action.payload.direction};
      return oStateReturn;

    case "CONFERENCE_DATA":
      LoggingService.getInstance().debug('CALLINFO REDUCER --- CONFERENCE_DATA', action.payload)
      if (state.inprogressCalls[action.payload.callId] ) {
        oStateReturn.inprogressCalls[action.payload.callId]["conferenceData"] = { messages: [], ...oStateReturn.inprogressCalls[action.payload.callId]["conferenceData"], ...action.payload};
      }
      return oStateReturn;

    case 'ACTIVE_CALL':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- ACTIVE_CALL', action.payload);
      // is it a valid numbrer
      if (action.payload.dialog){
        delete action.payload.dialog;

      }
      if (!action.payload.hasOwnProperty('muted')){
        action.payload.muted = false;
      }
      if (!action.payload.hasOwnProperty('held')){
        action.payload.held = false;
      }
      if (state.inprogressCalls[action.payload.callId]){
        oStateReturn.activeCallId = action.payload.callId;
      }

      LoggingService.getInstance().debug('oStateReturn', oStateReturn);
      LoggingService.getInstance().debug('state.inprogressCalls[action.payload]', state, state.inprogressCalls[action.payload]);

      return oStateReturn;

    case 'CALL_HUNG_UP':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- CALL_HUNG_UP', action.payload)

      // is it a number I called
      if (state.inprogressCalls[action.payload.callID]){
        // only hangup numbers i know about
        // remove it
        if (action.payload.callID === oStateReturn.activeCallId) {
          oStateReturn.activeCallId = undefined;
        }
        delete oStateReturn.inprogressCalls[action.payload.callID];

        // make the next call the activeCallId
        const calls = Object.keys(state.inprogressCalls);
        if (calls.length > 0){
          oStateReturn.activeCallId = calls[0];
        }
      }

      if (state.incomingCalls[action.payload.callID]) {
        delete oStateReturn.incomingCalls[action.payload.callID];
      }

      // if the hungup call is the transferCallId, delete transferCallId and transferToNbr
      if (action.payload.callID === oStateReturn.transferCallId) {
        delete oStateReturn.transferCallId;
        delete oStateReturn.transferToNbr;
      }
      LoggingService.getInstance().debug('aaaaaaahhhhhh bbbbaaadddd', action.payload);
      return oStateReturn;

    case 'ATTENDED_TRANSFER':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- ATTENDED_TRANSFER', action.payload);
      oStateReturn.transferCallId = action.payload.transferCallId;
      oStateReturn.transferToNbr = action.payload.transferToNbr;
      return oStateReturn;

    case 'CLEANUP_ATTENDED_TRANSFER':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- CLEANUP_ATTENDED_TRANSFER', action.payload);
      delete oStateReturn.transferCallId;
      delete oStateReturn.transferToNbr;
      return oStateReturn;

    case 'SAVE_AUDIO_SETTINGS':
      LoggingService.getInstance().debug('CALLINFO REDUCER --- SAVE_AUDIO_SETTINGS', action.payload);
      if (oStateReturn.inprogressCalls[oStateReturn.activeCallId]){
        oStateReturn.inprogressCalls[oStateReturn.activeCallId].audioSettings = action.payload;
      } else {
        LoggingService.getInstance().warn('WARN: no inprogress call found ', oStateReturn.activeCallId, oStateReturn.inprogressCalls)
      }
      return oStateReturn;

    default:
     return oStateReturn;
    }
};

export { callInfo };



// WEBPACK FOOTER //
// ./src/reducers/callInfo-reducer.js